<template>
  <div  style="width: 100%; margin: 0px; margin-top: 2px; font-size: 11px;" class="small-text" >
    <v-card>
      <v-simple-table dense class="font-size-11">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">
              Zone <br>Bookings
            </th>
            <th class="text-left">
              Asap
            </th>
            <th class="text-left">
              15
            </th>
            <th class="text-left">
              30
            </th>
            <th class="text-left">
              1H
            </th>
          </tr>
          </thead>
          <tbody>
          <tr style="background: white">
            <td >{{bookingForm.booking.zone != null ? bookingForm.booking.zone.name : ''}}</td>
            <td >{{asapBookings()}}</td>
            <td >{{bookingsInXMinutes(0, 15)}}</td>
            <td >{{bookingsInXMinutes(15, 30)}}</td>
            <td>{{bookingsInXMinutes(30,60)}}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
import { Overwatch } from "@/components/util/Overwatch.js";
import moment from "moment";

export default {
  name: "booking_zone_summary",
  components: {
  },
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    taxis: Array,
    bookings: Array,
    zones: Array,
    bookingForm: Object
  },
  computed: {
    
  },
  data() {
    return {
    };
  },
  methods: {
    upcomingBookings: function() {
      var bf = this.bookingForm;
      if (this.bookings && this.bookings.length) {
        return this.bookings.filter(function(b) {

          if (bf.booking.zone == null ) {
            return false;
          }

          return b.state == 'booked' && b.zone && b.zone.id == bf.booking.zone.id;
        });
      }
      return []
    },
    asapBookings: function() {
      if (this.upcomingBookings().length) {
        return this.upcomingBookings().filter(function(b) {
          return b.asap == true;
        }).length;
      }
      return 0;
    },
    bookingsInXMinutes: function(minMinutes, maxMinutes) {
      console.log(this.upcomingBookings());
      if (this.upcomingBookings().length) {
        return this.upcomingBookings().filter(function(b) {

          var time = moment(b.pickup_timestamp);

          var duration = -moment().diff(time, 'minutes');

          return (duration >= minMinutes && duration < maxMinutes);
        }).length
      }
    return 0
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

table { border-collapse: collapse; }
tr { border: none; }

ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  // color: green;
  font-weight: 800;
}

.small-text {
  font-size: 13px;
}
</style>
